import { render } from "./ModaSikisuu.vue?vue&type=template&id=5ac96c3c&scoped=true"
import script from "./ModaSikisuu.vue?vue&type=script&lang=js"
export * from "./ModaSikisuu.vue?vue&type=script&lang=js"

import "./ModaSikisuu.vue?vue&type=style&index=0&id=5ac96c3c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac96c3c"]])

export default __exports__